import { Patient } from '@bioliberty/lifemind';
import { ColumnDef } from '@tanstack/react-table';
import { useAuthentication } from '../../auth';
import { SortableHeader } from '../../components/DataTable/SortableHeader';
import { NoCapture } from '../../components/NoCapture';

export function usePatientTableColumns() {
  const currentUser = useAuthentication();

  const columnDefinitions: ColumnDef<Patient>[] = [
    {
      accessorKey: 'alias',
      header: ({ column }) => <SortableHeader column={column}>Unique Patient Identifier</SortableHeader>,
      cell: ({ row }) => <NoCapture>{row.getValue('alias')}</NoCapture>,
      minSize: 300
    },
    {
      accessorKey: 'createdAt',
      header: ({ column }) => <SortableHeader column={column}>Date Created</SortableHeader>,
      cell: ({ row }) => {
        return <>{new Date(row.getValue('createdAt')).toLocaleDateString()}</>;
      },
      minSize: 150
    },
    {
      accessorKey: 'lastActivityDate',
      header: ({ column }) => <SortableHeader column={column}>Last Activity</SortableHeader>,
      cell: ({ row }) => {
        const value: string = row.getValue('lastActivityDate');
        return <>{value ? new Date(value).toLocaleDateString() : ''}</>;
      },
      minSize: 150
    }
  ];

  if (currentUser.subtenants?.length) {
    columnDefinitions.splice(1, 0, {
      accessorKey: 'tenantId',
      header: ({ column }) => <SortableHeader column={column}>Clinic</SortableHeader>,
      cell: ({ row }) => {
        const subtenant = currentUser.subtenants?.find(({ name }) => name === row.getValue('tenantId'));
        return subtenant?.label ?? '';
      },
      minSize: 150
    });
  }

  return columnDefinitions;
}
